import { PaginationProps } from '@components/V4/Pagination';
import SessionModalSection, { ActionButton } from '@modules/Admin/components/ModalSection';
import { GetEnrollmentsByIdsDTO } from '@shared/clientTypes/DTOs/EnrollmentsDTO';
import { useState } from 'react';
import EnrollmentsList from './EnrollmentsList';
import EnrollmentsListChangeStatusForm from './EnrollmentsListChangeStatusForm';

interface EnrollmentsListSectionProps {
  enrollments?: GetEnrollmentsByIdsDTO['enrollments'];
  pagination: PaginationProps;
  areEnrollmentsLoading: boolean;
  allEnrollmentsIds: string[];
  onMentorModalOpen: (id: string) => void;
  onStudentModalOpen: (id: string) => void;
  onEnrollmentModalOpen: (id: string) => void;
}

const EnrollmentsListSection = (props: EnrollmentsListSectionProps) => {
  const {
    enrollments,
    pagination,
    areEnrollmentsLoading,
    allEnrollmentsIds,
    onMentorModalOpen,
    onStudentModalOpen,
    onEnrollmentModalOpen,
  } = props;

  const [isChangeStatus, setIsChangeStatus] = useState(false);

  const buttons: ActionButton[] = [
    {
      showButton: !isChangeStatus,
      buttonText: 'Change Status',
      onClick: () => setIsChangeStatus(true),
    },
  ];

  return (
    <>
      {isChangeStatus && (
        <EnrollmentsListChangeStatusForm
          enrollmentIds={allEnrollmentsIds ?? []}
          onCancel={() => setIsChangeStatus(false)}
        />
      )}
      <SessionModalSection sectionTitle={'Enrollments List'} buttonsArray={buttons}>
        <EnrollmentsList
          enrollments={enrollments}
          pagination={pagination}
          areEnrollmentsLoading={areEnrollmentsLoading}
          onMentorModalOpen={onMentorModalOpen}
          onStudentModalOpen={onStudentModalOpen}
          onEnrollmentModalOpen={onEnrollmentModalOpen}
        />
      </SessionModalSection>
    </>
  );
};

export default EnrollmentsListSection;
